import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from 'material-ui'
import styles from './chip-styles'
import './chip-styles.css'

const SelectableChip = ({
  description,
  handleAddChip,
  id,
  title,
  type,
  usedChipTypes,
}) => (
  <Chip
    onClick={() => handleAddChip(id, type)} // the 'type' param doesn't need to be passed a value, extra args won't do anything
    style={usedChipTypes.includes(id) ? styles.chipSelected : styles.chip}
    backgroundColor={usedChipTypes.includes(id) ? '#9FA8DA' : '#90CAF9'}
  >
    <div className="chip">
      <span className="chipTitle">{title}</span>
      <span className="chipBody">{description}</span>
    </div>
  </Chip>
)

SelectableChip.propTypes = {
  id: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  handleAddChip: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  usedChipTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default SelectableChip



// WEBPACK FOOTER //
// ./src/components/sitewide/Chips/SelectableChip.js